/** The studio header piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { StudioHeaderEvents } from './contract';
import { StudioHeaderView } from './StudioHeaderView';
import { useStudioHeader } from './useStudioHeader';

export function StudioHeader(props: PieceInput<StudioHeaderEvents>) {
  return <StudioHeaderView {...useStudioHeader(props)} />;
}
